import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { UploadImageApi } from '../upload-api';
import { useGuestMode } from '@/composables/tech-qa/use-guest-mode';

@injectable()
export class UploadImageApiImpl extends PsHttpService implements UploadImageApi {
  get options() {
    return {
      // baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/image`,
      baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/material/tech-qa`,
      headers: {
        'X-API-Version': '1.0',
      },
      guestBaseUrl: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/guest/material/tech-qa`,
    };
  }

  uploadImage(file: File, onProgress?: (percent: number) => void): Promise<Record<any, any>> {
    const { isGuestMode } = useGuestMode();
    const baseURL = isGuestMode.value ? this.options.guestBaseUrl : this.options.baseURL;

    const formData = new FormData();
    formData.append('file', file);

    return this.post<PatSnapCommonResponseData<Record<any, any>>>({
      baseURL,
      url: '/upload-img',
      data: formData,
      onUploadProgress: (progressEvent) => {
        if (!progressEvent.total) return;

        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);

        onProgress?.(percent);
      },
    }).then((res) => {
      return res.data as Record<any, any>;
    });
  }
}
